exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".footers[data-v-c83683e6]{text-align:center;font-size:14px;color:#808695;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.footers .title[data-v-c83683e6]{font-size:14px;color:#808695}.ivu-global-footer[data-v-c83683e6]{margin:15px 0px;text-align:center;-webkit-box-sizing:border-box;box-sizing:border-box;margin-left:210px}", ""]);

// exports
